import KeywordItem from './src/keyword-item';

export default KeywordItem;
